import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'

export { StyledIconButton }

interface Props {
  title: string
  onClick?: any
  icon: any
}

const StyledIconButton = ({ title, onClick, icon }: Props) => {
  return (
    <Tooltip title={title}>
      <IconButton
        aria-label={title}
        onClick={onClick}
        sx={{ maxHeight: '40px', maxWidth: '40px' }}
      >
        {icon}
      </IconButton>
    </Tooltip>
  )
}
